module.exports = __webpack_public_path__ + "media/images/flags/BL-eb6ba077ed63f27b271c60ce7b87ae48.svg";